// ScrollToTop.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  initGoogleAnalytics,
  trackGaPageView,
} from '../../utils/googleAnalytics';

const ScrollToTop = ({ children }) => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    initGoogleAnalytics();
    trackGaPageView(`${pathname}${search}`);
  }, [pathname, search]);

  return children;
};

export default ScrollToTop;
